// BankInfoForm.styles.tsx
import { styled } from '@mui/material/styles';
import { Paper, Box, Button, TextField } from '@mui/material';

export const FormContainer = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(5),
    margin: theme.spacing(3, 'auto'),
    maxWidth: 900,
    boxShadow: 'none',
}));
export const FormTitle = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '1.8rem',
    color: 'black',
}));

export const FormSection = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2, 3),
}));

export const SectionTitle = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    fontSize: '1.2rem',
    color: theme.palette.secondary.main,
    borderBottom: `2px solid ${theme.palette.secondary.light}`,
    paddingBottom: theme.spacing(1),
}));

export const FormRow = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: theme.spacing(2.5),
    marginBottom: theme.spacing(2.5),
}));

export const FormField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
        borderRadius: theme.spacing(1),
    },
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(3),
    marginTop: theme.spacing(4),
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
    minWidth: 140,
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.spacing(2),
    fontWeight: 600,
    textTransform: 'none',
    background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
    color: '#fff',
    '&:hover': {
        opacity: 0.9,
    },
}));

export const ResetButton = styled(Button)(({ theme }) => ({
    minWidth: 140,
    padding: theme.spacing(1.5, 3),
    borderRadius: theme.spacing(2),
    fontWeight: 600,
    textTransform: 'none',
    borderColor: theme.palette.grey[400],
    color: theme.palette.grey[700],
    '&:hover': {
        backgroundColor: theme.palette.grey[100],
    },
}));
